
























































































// TODO: Collapse v-list-group when a child-element is selected
import store from "@/store";

const isNotProduction = () =>
  process.env.VUE_APP_ENV === "test" ||
  process.env.VUE_APP_ENV === "acceptance";
const isProduction = () => process.env.VUE_APP_ENV === "production";
const isAlkmaar = () => process.env.VUE_APP_LOCATION === "alkmaar";
const isOosterwolde = () => process.env.VUE_APP_LOCATION === "oosterwolde";
const isApeldoorn = () => process.env.VUE_APP_LOCATION === "apeldoorn";

const formChildren = [
  !isOosterwolde()
    ? {
        title: "Kuur medicatiesets",
        icon: "mdi-folder-information",
        route: "/forms/requestOfflineAssortment"
      }
    : {},
  {
    title: "Assortimentsaanvraag",
    route: "/forms/requestNewProduct",
    icon: "mdi-note-plus-outline"
  },
  {
    title: "Foto aanvragen",
    icon: "mdi-camera",
    route: "/forms/requestPhoto"
  },
  isNotProduction() ||
  (isProduction() && isOosterwolde()) ||
  (isProduction() && isApeldoorn())
    ? {
        title: "Aanvraagformulier rollen",
        route: "/forms/requestImmediateProduct",
        icon: "mdi-paper-roll-outline"
      }
    : {},
  {
    title: "Nieuwe afdeling",
    route: "/forms/requestNewDepartment",
    icon: "mdi-domain"
  },
  {
    title: "Afdeling stopzetten",
    route: "/forms/requestStopDepartment",
    icon: "mdi-close-octagon-outline"
  }
];

if ((isApeldoorn() && isProduction()) || isNotProduction()) {
  formChildren.push({
    title: "Melding onvolkomenheden",
    route: "/forms/reportImperfectionInceptionApeldoorn",
    icon: "mdi-alert"
  });
}

if ((isOosterwolde() && isProduction()) || isNotProduction()) {
  formChildren.push({
    title: "Melding onvolkomenheden",
    route: "/forms/reportImperfectionInceptionOosterwolde",
    icon: "mdi-alert"
  });
}

if (isNotProduction() || (isAlkmaar() && isProduction())) {
  formChildren.push({
    title: "Melding onvolkomenheden",
    route: "/forms/reportImperfectionInceptionAlkmaar",
    icon: "mdi-alert"
  });
}

if (isNotProduction()) {
  formChildren.push({
    title: "Melding onvolkomenheden",
    route: "/forms/reportImperfection",
    icon: "mdi-alert"
  });
}

export default {
  name: "MainMenu",
  components: {},
  props: ["menu", "drawer"],
  watch: {
    drawer(newVal: boolean, oldVal: boolean) {
      this.setDrawer(newVal);
    }
  },
  data() {
    return {
      isManager: false,
      drawerOpen: false,
      user: {},
      items: [
        {
          title: "Dashboard",
          icon: "mdi-monitor-dashboard",
          route: "/"
        },
        {
          title: "Assortiment Overzicht",
          icon: "mdi-format-list-text",
          route: "/products"
        },
        {
          title: "Assortimentsupdate",
          icon: "mdi-swap-horizontal",
          route: "/assortment-update"
        },
        {
          title: "Formulieren",
          icon: "mdi-form-select",
          children: formChildren
        },
        // {
        //   title: "Facturen",
        //   icon: "mdi-receipt",
        //   route: "/invoices"
        // },
        {
          title: "Inpakopdrachten",
          icon: "mdi-package-variant-closed",
          route: "/packing-order"
        },
        (!isAlkmaar() && isProduction()) || isNotProduction()
          ? {
              title: "Leveringsafspraken",
              icon: "mdi-calendar-month",
              route: "/calendar"
            }
          : null,

        {
          title: "Serviceproducten",
          icon: "mdi-cart",
          route: "/orders-add"
        },
        !isProduction()
          ? {
              title: "Accountbeheer",
              icon: "mdi-account-settings",
              route: "/account-management",
              role: ["Management"]
            }
          : null,
        {
          title: "Veelgestelde vragen",
          icon: "mdi-comment-question",
          route: "/faq"
        },
        {
          title: "Contact",
          icon: "mdi-phone",
          route: "/contact"
        },
        {
          title: "Beveiliging",
          icon: "mdi-security",
          route: "/settings"
        }
      ]
    };
  },
  mounted() {
    this.isManager = store.getters["auth/isManager"];
  },
  methods: {
    hasManagerRole: function(roles: string[]) {
      // If no role is set, show
      if (roles === undefined) {
        return true;
      }
      // If logged-in user is of type Manager, and item should
      // only be seen by the manager role.
      if (roles.includes("Management") && this.isManager) {
        return true;
      }
      return false;
    },
    setDrawer: function(val: boolean) {
      this.drawerOpen = val;
    },
    hasActiveChild: function(item: any) {
      return item?.children?.find(el => el.route === this.$route.path);
    },
    getChildrenWithRoute: function(children: any) {
      return children.filter(child => child.route !== undefined);
    }
  }
};
